var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('a',{on:{"click":function($event){return _vm.toggleValue()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.displayTitle))}}),(_vm.showIcon)?_c('span',{staticClass:"glyphicon marginal-left-m",class:_vm.icon}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }